import React from "react";
import Modal from "../../Components/Base/Modal";
import { SelectInput } from "../../Components";
import Unlock from "./Unlock";
const selectEthnicityList = [{ id: "All", value: "All" }];
export default function ModalEthnicity(props) {
  const changeSelectedEthenicity = (item) => {
    props.setSelectedEthenicity(item.value)
  }
  return (
    <Modal addClass="modalCamp" close={props.close}>
      <div className="filterModal modal__camp">
        {props.isUserHasSubscription ?
          <div className="modal__assetDetail-delete perm long">
            <h4>Ethnicity</h4>
            <div className="dropdown-item age-select">
              <SelectInput
                selected={selectEthnicityList.filter(item => item.value === props.selectedEthenicity)[0]}
                onChange={changeSelectedEthenicity}
                list={selectEthnicityList}
                value={props.selectedEthenicity}
              />
            </div>
            <div className="breakLine">
              <div className="campaignsCreate__btns filterbuttons">
                <div class="campaignsCreate__btns-row"><button className="clearButton" onClick={() => props.setSelectedEthenicity('')}>Clear</button></div>
                <button className="button primary" onClick={props.handleSearch}>
                  Save
                </button>
              </div></div>
          </div> :
          <Unlock onSaveCamp={props.close}></Unlock>
        }
      </div>
    </Modal>
  );
}
